@if (hideFromConfig$ | async; as hideFromConfig) {
	@if (!hide) {
		@switch (true) {
			@case (hideFromConfig.visibilityAndroidBanner && android) {
				<section class="mobile-label-create-notification">
					<div class="mobile-label-create-notification__icon">
						<app-svg-rsb-logo-ring
							class="mobile-label-create-notification__icon-logo"
						></app-svg-rsb-logo-ring>
					</div>
					<div class="mobile-label-create-notification__information">
						<h2 class="mobile-label-create-notification__information-title">
							Добавьте ярлык Русский Стандарт Онлайн на&nbsp;экран &laquo;Домой&raquo;
						</h2>
						<p class="mobile-label-create-notification__information-text">
							Нажмите на&nbsp;иконку
							<span class="mobile-label-create-notification__information-text-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 128 512"
									id="IconChangeColor"
									height="20"
									width="5"
								>
									<path
										d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
										id="mainIconPathAttribute"
									></path>
								</svg>
							</span>
							и&nbsp;в&nbsp;меню выберите &laquo;Добавить на&nbsp;главный экран&raquo;
						</p>
					</div>

					<button
						class="button-reset close mobile-label-create-notification__close"
						tabindex="20"
						type="button"
						(click)="hide = true"
					></button>
				</section>
			}

			@case (hideFromConfig.visibilityIOSBanner && ios) {
				<section class="mobile-label-create-notification">
					<div class="mobile-label-create-notification__icon">
						<app-svg-rsb-logo-ring
							class="mobile-label-create-notification__icon-logo"
						></app-svg-rsb-logo-ring>
					</div>
					<div class="mobile-label-create-notification__information">
						<h2 class="mobile-label-create-notification__information-title">
							Добавьте ярлык Русский Стандарт Онлайн на&nbsp;экран &laquo;Домой&raquo;
						</h2>
						<p class="mobile-label-create-notification__information-text">
							Нажмите на&nbsp;иконку
							<span class="mobile-label-create-notification__information-text-icon">
								<svg
									width="14"
									height="16"
									viewBox="0 0 14 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6.99606 10.4493C7.33521 10.4493 7.62704 10.1941 7.62704 9.89632V2.61586L7.57972 1.5525L8.10817 2.05583L9.30704 3.20425C9.41746 3.31768 9.57521 3.37439 9.73296 3.37439C10.0563 3.37439 10.3087 3.16172 10.3087 2.87107C10.3087 2.7222 10.2377 2.60877 10.1194 2.50244L7.45352 0.191405C7.29577 0.0496234 7.16169 0 6.99606 0C6.83831 0 6.70423 0.0496234 6.53859 0.191405L3.87268 2.50244C3.75437 2.60877 3.69127 2.7222 3.69127 2.87107C3.69127 3.16172 3.92789 3.37439 4.25915 3.37439C4.40901 3.37439 4.58254 3.31768 4.69296 3.20425L5.88394 2.05583L6.42028 1.5525L6.37296 2.61586V9.89632C6.37296 10.1941 6.6569 10.4493 6.99606 10.4493ZM2.47662 16H11.5234C13.1718 16 14 15.2627 14 13.8024V6.72751C14 5.26717 13.1718 4.52991 11.5234 4.52991H9.32282V5.67125H11.4997C12.2806 5.67125 12.7301 6.05405 12.7301 6.79132V13.7386C12.7301 14.4759 12.2806 14.8587 11.4997 14.8587H2.49239C1.70366 14.8587 1.26986 14.4759 1.26986 13.7386V6.79132C1.26986 6.05405 1.70366 5.67125 2.49239 5.67125H4.67718V4.52991H2.47662C0.828169 4.52991 0 5.26717 0 6.72751V13.8024C0 15.2627 0.828169 16 2.47662 16Z"
										fill="#377CF5"
									/>
								</svg>
							</span>
							внизу экрана и&nbsp;выберите &laquo;На&nbsp;экран
							&quot;Домой&quot;&raquo;
						</p>
					</div>

					<button
						class="button-reset close mobile-label-create-notification__close"
						tabindex="20"
						type="button"
						(click)="hide = true"
					></button>
				</section>
			}
		}
	}
}
